export class News{
    public Id:number;
    public DateAdd:string;
    public Title:string;
    public Content:string;
}


// WEBPACK FOOTER //
// ./src/app/news/models/news.ts